import { Burying } from "@/utils/Burying";

const KS_LANDINGPAGE_DOWNLOAD_CLICK = "wb_download_click";

function getUserId(): number {
  const userState =
    (window as any).App &&
    (window as any).App.$store &&
    (window as any).App.$store.state &&
    (window as any).App.$store.state.user;
  const userInfo = userState && userState.info;
  return userInfo && userInfo.id ? userInfo.id : 0;
}

/** 快手直播间落地页 - 下载点击埋点（download_url 为下载页地址） */
export function kszbCollectDownloadClick() {
  const userId = getUserId();
  Burying({
    eventname: KS_LANDINGPAGE_DOWNLOAD_CLICK,
    eventtype: "track",
    uid: userId,
    properities: {
      user_id: String(userId),
      download_url: window.location.href,
    },
  });
}
